// @ts-ignore
import Config from 'Config';

const ADMIN_UPGRADE = '/admin_upgrade';

const MARKETING = Config.Environment.R101_MARKETING_URL;
const ZENDESK = 'https://help.remind.com/hc/en-us';
const GOOGLE_PLAY =
  'https://play.google.com/store/apps/details?id=com.remind101&referrer=utm_source%3Dremind101%26utm_medium%3D%252Fapps%26utm_campaign%3Dget-it-on-google-play';

const ENGAGEMENT_RATINGS_HC = `${ZENDESK}/articles/360006079220`;
const SETUP_SFTP = `${ZENDESK}/articles/360001678150`;

const LinkConstants = {
  ADMIN_UPGRADE,
  ADMIN_UPGRADE_CONTACT: `${ADMIN_UPGRADE}/contact_us`,
  ADMIN_UPGRADE_FORM:
    'https://docs.google.com/forms/d/e/1FAIpQLSei36UlbRpTKWOSznvLK7YzrCauyoZKg82BLLz7bmI_KrwC2A/viewform',
  MARKETING,
  SIGN_UP: `${MARKETING}/?sign-up=true`,
  ABOUT: `${MARKETING}/about`,
  BLOG: `${MARKETING}/blog`,
  CAREERS: `${MARKETING}/about#careers`,
  COACHING: `${MARKETING}/coaching`,
  COMMUNITY: `${MARKETING}/community`,
  COMMUNITY_GUIDELINES: `${MARKETING}/community-guidelines`,
  ENGAGEMENT_RATINGS: `${MARKETING}/engagement-ratings`,
  FAMILIES: `${MARKETING}/families`,
  FEATURES: `${MARKETING}/features`,
  HIGHER_EDUCATION: `${MARKETING}/higher-education`,
  HOW_IT_WORKS_TEACHERS: `${MARKETING}/how-it-works/teachers`,
  PLANS: `${MARKETING}/plans`,
  PLANS_GRID: `${MARKETING}/plans#plans-grid`,
  MOBILE_PLANS: `${MARKETING}/settings/remind_plans`,
  PLANS_CONTACT: 'plans@remind101.com',
  PARTNERS: `${MARKETING}/partners`,
  PRESS: `${MARKETING}/press`,
  PRIVACY_POLICY: `${MARKETING}/privacy-policy`,
  RESOURCES: `${MARKETING}/resources`,
  SCHOOLS: `${MARKETING}/schools`,
  TEACH_SMALL: `${MARKETING}/teach-small`,
  TEACHERS: `${MARKETING}/teachers`,
  TRUST_SAFETY: `${MARKETING}/trust-safety`,
  TERMS_OF_SERVICE: `${MARKETING}/terms-of-service`,
  DISTRICT_AGREEMENT: `${MARKETING}/district-agreement`,
  SCHOOL_AGREEMENT: `${MARKETING}/school-agreement`,
  JOIN: `${MARKETING}/join`,
  DATA_PRACTICE: `${MARKETING}/data-practices`,
  SUPPORT_CALL: `${MARKETING}/f/support_call`,

  APP_DOWNLOAD: 'http://rmd.me/a',
  HELP: 'https://help.remind.com',

  BILLING_EMAIL: 'billing@remindhq.com',
  DISTRICTS_EMAIL: 'districts@remind.com',
  REPORT_EMAIL: 'report@remindhq.com',
  SCHOOLS_EMAIL: 'schooladmin@remindhq.com',
  SUPPORT_EMAIL: 'support@remindhq.com',

  FACEBOOK: 'https://facebook.com/remindhq',
  TWITTER: 'https://twitter.com/remindhq',
  INSTAGRAM: 'https://instagram.com/remindhq',
  PINTEREST: 'https://pinterest.com/remindhq',
  YOUTUBE: 'https://youtube.com/remindhq',
  LINKEDIN: 'https://www.linkedin.com/company/remind101',
  GOOGLE_PLUS: 'https://plus.google.com/+remindhq',

  APP_STORE: 'https://itunes.apple.com/us/app/remind101/id522826277',
  GOOGLE_PLAY,
  GOOGLE_PLAY_AUTOLOGIN_PARAM: '%26utm_term%3Dautologin_',
  GOOGLE_PLAY_SHORT_LINK_REFERRER_AUTOLOGIN_PARAM: '?referrer=utm_term%3Dautologin_',
  MAC_APP_STORE: 'https://itunes.apple.com/us/app/remind-safe-classroom-communication/id1059891751',
  IOS_APP_OR_APP_STORE: 'https://remind.com/remind_ios_app_store',
  ANDROID_APP_OR_APP_STORE: `intent://a#Intent;scheme=rmd;package=com.remind101;S.browser_fallback_url=${encodeURI(
    GOOGLE_PLAY
  )};end`,

  UTM_SOURCE_ADMIN: 'remind_admin',
  UTM_SOURCE_TEACHER: 'remind_teacher',
  UTM_SOURCE_UPGRADE_MODAL: 'upgrade_modal',
  UTM_MEDIUM_PRODUCT: 'product',
  UTM_CAMPAIGN_UNPAID_ORG: 'admin_unpaid_organization',
  UTM_CAMPAIGN_TEACHER_UPSELL: 'teacher_upsell_unpaid_organization',
  UTM_CAMPAIGN_CLASS_LIMITS: 'class_limits_upgrade',

  ZENDESK,
  AUTO_MESSAGING_HELP: `${ZENDESK}/articles/360003789559`,
  COACHING_HELP: `${ZENDESK}/articles/360010122479`,
  COACHING_HELP_CUSTOM_PLAN: `${ZENDESK}/articles/360010122479#h_cc928121-11b0-4915-aaaf-cc00b0c86e1b`,
  COACHING_HELP_SUBSCRIPTION: `${ZENDESK}/articles/360010122479#h_ff1da28a-0c07-4dbe-950d-de84292b604f`,
  CHAT_RESTRICTIONS: `${ZENDESK}/articles/209063506`,
  COMMS_CONTROL_BACKFILL: `${ZENDESK}/articles/360010513520`,
  CONNECT_SIS: `${ZENDESK}/articles/115001644730`,
  CUSTOMIZED_MESSAGING_HELP: `${ZENDESK}/articles/360007903119`,
  DIRECT_ADD_ERROR: `${ZENDESK}/articles/201816825`,
  ENABLE_COOKIES: `${ZENDESK}/articles/203136915`,
  ENGAGEMENT_RATINGS_HC,
  ENGAGEMENT_RATINGS_HC_NO_RATING: `${ENGAGEMENT_RATINGS_HC}#no_rating`,
  FORGOT_PASSWORD: `${ZENDESK}/articles/201920345`,
  FORMAT_ONEROSTER: `${ZENDESK}/articles/360001395940`,
  FORMAT_REMIND: `${ZENDESK}/articles/360000118400`,
  FORMAT_REMINDV2: `${ZENDESK}/articles/360013836460`,
  FREE_PRODUCT_LIMITS: `${ZENDESK}/articles/202540798`,
  LINK_CLASS_TO_SCHOOL: `${ZENDESK}/articles/360005513239`,
  INCREASE_ENGAGEMENT: `${ZENDESK}/articles/360000105700`,
  MANAGE_PROFILE: `${ZENDESK}/articles/360006299180#Managingyour`,
  MOG: `${ZENDESK}/articles/203179827`,
  NO_DEVICES: `${ZENDESK}/articles/206430755`,
  PARENTAL_CONSENT: `${ZENDESK}/articles/210737926`,
  PENDING_ROLES: `${ZENDESK}/articles/360005941860`,
  REQUEST_TO_JOIN: `${ZENDESK}/articles/360009013520`,
  ROSTERING_ENFORCEMENT: `${ZENDESK}/articles/360009403279`,
  ROSTERING_GUIDE: `${ZENDESK}/articles/115001899304`,
  ROSTERING_HOLDS: `${ZENDESK}/articles/360000123860`,
  SELECTING_SCHOOL: `${ZENDESK}/articles/207536236`,
  SETUP_SFTP,
  SETUP_SFTP_DIRECT_SYNC: `${SETUP_SFTP}-Set-up-a-direct-sync-via-SFTP`,
  SUPPORTED_BROWSERS: `${ZENDESK}/articles/202409729`,
  UNCLAIMED_GROUPS: `${ZENDESK}/articles/360010078559`,
  UNMATCHED_STUDENTS: `${ZENDESK}/articles/360000719959`,
  UNREACHABLE_DEVICES: `${ZENDESK}/articles/360001686959`,
  UPDATE_SIS: `${ZENDESK}/articles/360000336184`,
  URGENT_MESSAGING_HELP: `${ZENDESK}/articles/360006252139`,
  WHAT_IS_REMIND: `${ZENDESK}/articles/201342445`,
  WIDGET_INSTRUCTIONS: `${ZENDESK}/articles/204876696`,
  ZENDESK_PLANS: `${ZENDESK}/categories/360000009170`,

  CONTACT_FORM: `${ZENDESK}/requests/new`,

  DOWNLOAD_CHROME: 'https://www.google.com/chrome/browser/desktop/',
  DOWNLOAD_FIREFOX: 'https://www.getfirefox.com/',

  CLEVER_CALLBACK_URL: `${MARKETING}/v2/users/auth/clever/sync_setup/callback`,
  CLEVER_ADD_REMIND: 'https://schools.clever.com/applications/add/remind',
  CLEVER_DATA_SHARING: 'https://schools.clever.com/school/applications/remind/sharing',
  CLEVER_DATA_SHARING_HELP:
    'https://support.clever.com/hc/en-us/articles/203115007-How-do-I-set-my-sharing-permissions-for-applications',
  CLEVER_SUPPORT_DISTRICT_ADMIN: 'https://support.clever.com/hc/en-us/categories/200147297',
  CLEVER_SUPPORT: 'https://support.clever.com/hc/en-us/requests/new',
  CLEVER_APPLICATIONS: 'https://schools.clever.com/applications',
  CLEVER_TEACHER_NOTIFICATION: `${ZENDESK}/articles/360000066310`,
  CLEVER_STUDENT_NOTIFICATION: `${ZENDESK}/articles/360000991644`,

  PLANS_OPTIONS: 'https://plans.remind.com/RenewalsQ22020_Renewal-Options.html',

  PARENT_ONBOARDING_VIDEO: 'https://www.youtube.com/watch?v=dYpFv-JnT0s',
  DIRECT_ADD_VIDEO: 'https://www.youtube.com/watch?v=hRIFV-r6RM8',

  NCES: 'https://nces.ed.gov',

  COACHING_EMAIL: 'mailto:coaching@remind101.com',
  CONTACT_HELP: 'https://help.remind.com/hc/en-us/requests/new',

  SIS_SYNC_HELP: 'https://rmd.me/help',

  ADMIN_INTEGRATIONS_HELP: 'https://help.remind.com/hc/en-us/articles/360015003179-Setting-up-video-app-integrations',
};

export const ConstructedLinks = {
  PLANS_GRID_FROM_FREE_PRODUCT_LIMITS: `${LinkConstants.PLANS}?utm_source=${LinkConstants.UTM_SOURCE_UPGRADE_MODAL}&utm_medium=${LinkConstants.UTM_MEDIUM_PRODUCT}&utm_campaign=${LinkConstants.UTM_CAMPAIGN_CLASS_LIMITS}#plans-grid`,
};

export default LinkConstants;
